import L from 'leaflet';

import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';

// NOTA: es sobreescriu l'icona per defecte del Marker de Leaflet per un bug no resolt de la llibreria.
//       URL de la issue: https://github.com/Leaflet/Leaflet/issues/4968
L.Marker.prototype.options.icon = L.icon({
	iconUrl,
	iconShadowUrl,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	tooltipAnchor: [16, -28],
	shadowSize: [41, 41]
});
/**
 * Rellena con 0 el valor especificado por parametro hasta llegar a una
 * longitud igual a "fill"
 *
 * @param {type} value
 * @param {type} fill
 * @returns {unresolved}
 */
const fillTo = function(value, fill) {
	//El valor por defecto es 3, por lo tanto si no hay variable fill la ponemos a 3.
	if (fill === null) {
		fill = 3;
	}

	var len = value.toString().length;
	var dif = fill - len;
	var fill = '';
	//Se itera tantas veces como la diferencia entre el valor de relleno y la longitud del valor
	for (var i = 0; i < dif; i++) {
		fill = fill.concat('0');
	}
	return fill.concat(value);
};

const LeafletBaseSMCLayer = L.TileLayer.extend({
	getTileUrl: function(coords) {
		//Només tenim que assegurar-nos que el zoom te dos dígits
		let z = '0' + this._getZoomForUrl();
		z = z.slice(-2);

		if (this._map && !this._map.options.crs.infinite) {
			var invertedY = this._globalTileRange.max.y - coords.y;
			if (this.options.tms) {
				coords.y = invertedY;
			}
			coords['-y'] = invertedY;
		}

		var x = omplirDimesions(coords.x);
		var y = omplirDimesions(coords.y);

		function omplirDimesions(param) {
			var str = param.toString();
			var dim = '00';
			var digDim = '0';
			if (str.length === 4) {
				digDim = str[0];
				param = str.slice(1);
			}
			return { point: param, dim: dim + digDim };
		}

		var data = {
			r: L.Browser.retina ? '@2x' : '',
			s: this._getSubdomain(coords),
			x: x.point,
			y: y.point,
			z: z,
			dimX: x.dim,
			dimY: y.dim
		};

		data['y'] = fillTo(data['y'], 3);
		data['x'] = fillTo(data['x'], 3);

		return L.Util.template(this._url, L.Util.extend(data, this.options));
	}
});

export const generarCapaBase = options => {
	if (options === undefined) {
		options = optionsBaseMeteocat;
	}
	return new LeafletBaseSMCLayer('http://static-m.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png', { ...options });
};

//TODO s'hauria de modificar totes les referencies a capaBase per generarCapaBase. Per evitar utilitzar la mateixa instancia de la capa.
//export const capaBase = L.tileLayer('http://static-m.meteo.cat/tiles/fons/GoogleMapsCompatible/{z}/000/{dimX}/{x}/000/{dimY}/{y}.png');
export const optionsBaseMeteocat = {
	maxZoom: 13,
	minZoom: 7,
	attribution: 'Imagery © <a href="http://www.meteo.cat/">Meteocat</a>',
	tms: true
};

/**
 * Crea un objecte L.Map, agafant com capa base la layer configurada al mètode generarCapaBase(). Centrat a Catalunya
 *
 * @param {div || String} ref
 */
export const crearMapa = (ref, nivellZoomMapaPerDefecte, centre) => {
	const capaBase = generarCapaBase(optionsBaseMeteocat);

	const configuracioMapa = {
		maxZoom: 13,
		minZoom: maxNativeZoomCatalunya,
		zoom: nivellZoomMapaPerDefecte,
		maxBounds: [[43, -0.06], [40.37, 3.57]],
		center: convertToLatLong(centre),
		layers: [capaBase],
		attributionControl: false
	};

	return L.map(ref, configuracioMapa);
};

const convertToLatLong = coordenades => {
	if (coordenades) {
		return L.latLng(coordenades.latitud, coordenades.longitud);
	}
};

export const coordenadesCentreCatalunyaPerMonitorizacioRadar = { latitud: 41.68669, longitud: 1.61224 };

export const maxNativeZoomCatalunya = 7;



// WEBPACK FOOTER //
// ./src/components/commons/mapa.js